import type { AddControlParentsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (
  affectedRows: number
): AddControlParentsMutation => {
  return {
    insert_control_parent: {
      __typename: 'control_parent_mutation_response',
      affected_rows: affectedRows,
    },
  };
};

export const useCreateControlParentsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.control.createParents.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.control.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.control.controlsBasic.queryKey(),
        });
        // COI-471 parity: Apollo twin also evicts `control_group`.
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.controlGroup.pathKey(),
        });
      },
    }),
  });

  return {
    createControlParents: async (
      objects: { ControlId: string; ParentId: string }[]
    ): Promise<AddControlParentsMutation> => {
      const result = await mutation.mutateAsync({ objects });

      return mapTrpcResponseToGraphQL(result.affected_rows);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
